/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_FailedInputs */

const cs_jobs_failed = /** @type {(inputs: Jobs_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úloha selhala`)
};

const en_jobs_failed = /** @type {(inputs: Jobs_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job failed`)
};

/**
* | output |
* | --- |
* | "Job failed" |
*
* @param {Jobs_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_failed = /** @type {((inputs?: Jobs_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_failed(inputs)
	return cs_jobs_failed(inputs)
});